"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Trash32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M16.99 4c.834 0 1.51.668 1.51 1.5V6h5.51A.99.99 0 0125 7.005v.99c0 .415-.245.773-.602.926.071.183.105.388.092.602l-.936 16.013A1.573 1.573 0 0121.99 27H10.004a1.57 1.57 0 01-1.562-1.466l-.89-16.013c-.011-.207.02-.405.086-.585A.994.994 0 017 7.996v-.991A.995.995 0 017.99 6h5.51v-.5c0-.832.67-1.5 1.51-1.5h1.98zm6.055 5H9a.433.433 0 00-.45.466l.89 16.013a.57.57 0 00.563.521H21.99c.293 0 .55-.24.566-.523l.936-16.013A.432.432 0 0023.045 9zM20 11a.5.5 0 01.5.5v11.51a.5.5 0 01-1 0V11.5a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v11.51a.5.5 0 01-1 0V11.5a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v11.51a.5.5 0 01-1 0V11.5a.5.5 0 01.5-.5zm8-4H8v1h16.002L24 7.995v-.99V7zm-7.01-2h-1.98a.5.5 0 00-.51.5V6h3v-.5c0-.277-.225-.5-.51-.5z", className: "trash-32_svg__path-1" }))); };
var StyledTrash32 = styled_components_1.default(Trash32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledTrash32;
var templateObject_1;
//# sourceMappingURL=Trash32.js.map